export var RootType = {
    UPDATE_TOKEN: "UPDATE_TOKEN",
    UPDATE_LOGINMODEL: "UPDATE_LOGINMODEL",
    UPDATE_MENULIST: "UPDATE_MENULIST",
    UPDATE_REGIONTREE: "UPDATE_REGIONTREE",
    UPDATE_CONFIG: "UPDATE_CONFIG",
    UPDATE_HOMESHOW: "UPDATE_HOMESHOW",
    UPDATE_OPENED_CODE_DATA: "UPDATE_OPENED_CODE_DATA",
    UPDATE_EDI_STATUS: "UPDATE_EDI_STATUS",
    UPDATE_CAN_SELECT_BATCH: "UPDATE_CAN_SELECT_BATCH",
    UPDATE_CAN_SEND_EMAIL: "UPDATE_CAN_SEND_EMAIL",
    UPDATE_IS_ERP: "UPDATE_IS_ERP",
    UPDATE_MSG_TYPE: "UPDATE_MSG_TYPE",
    UPDATE_SERVICE_DATA: "UPDATE_SERVICE_DATA",
    UPDATE_SERVICE_FLAG: "UPDATE_SERVICE_FLAG",
    UPDATE_ALL_SETTING_SCALE: "UPDATE_ALL_SETTING_SCALE",
};
export default RootType;
